import Vue from 'vue'
import Router from 'vue-router'
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/error/401',
    component: () => import('@/views/error/401'),
    hidden: true,
  },
  {
    path: '/error/404',
    component: () => import('@/views/error/404'),
    hidden: true,
  },

  {
    path: '',
    component: Layout,
    name: 'Info',
    hidden: true,
    children: [
      {
        path: '/info',
        component: () => import('@/views/info/index'),
      },
    ],
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
]

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: 'history',
  routes: constantRouterMap,
})

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "System",
  //     meta: {title: "系统管理", permissions: ["admin", "role"], icon: "system"},
  //     children: [
  //         {
  //             path: "/admin/list",
  //             name: "Admin",
  //             component: () => import("@/views/admin/index"),
  //             meta: {title: "管理员列表", permissions: ["admin"]}
  //         },
  //         {
  //             path: "/roles",
  //             name: "Role",
  //             component: () => import("@/views/role/index"),
  //             meta: {title: "角色列表", permissions: ["role"]}
  //         }
  //     ]
  // },
  {
    path: '',
    component: Layout,
    name: 'Index',
    redirect: '/summary',
    alwaysShow: true,
    meta: {
      title: '首页',
      icon: 'dashboard',
      permissions: ['admin', 'index'],
    },
    children: [
      {
        path: '/summary',
        name: 'DashboardSummary',
        meta: {
          title: '汇总统计',
          affix: true,
          permissions: ['admin', 'index'],
        },
        component: () => import('@/views/dashboard/summary'),
      },
      {
        path: '/clientStats',
        name: 'DashboardClientStats',
        meta: {
          title: '客户统计',
          permissions: ['admin', 'index'],
        },
        component: () => import('@/views/dashboard/clientStats'),
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'AppClient',
    meta: {
      title: '客户端管理',
      permissions: [
        'admin',
        'appClientList',
        'channelList',
        'appClientFinance',
        'rechargeLogAll',
        'appClientQuotaAccountLogAll',
      ],
      icon: 'users',
    },
    children: [
      {
        path: '/app-client/list',
        name: 'AppClientList',
        component: () => import('@/views/appClient/index'),
        meta: { title: '客户列表', permissions: ['admin', 'appClientList'] },
      },
      {
        path: '/channel/list',
        name: 'ChannelList',
        component: () => import('@/views/channel/index'),
        meta: { title: '渠道列表', permissions: ['admin', 'channelList'] },
      },
      {
        path: '/app-client/finance',
        name: 'AppClientFinance',
        component: () => import('@/views/appClient/finance'),
        meta: { title: '客户财务', permissions: ['admin', 'appClientFinance'] },
      },
      {
        path: '/app-client/rechargeLogAll',
        name: 'appClientrechargeLogAll',
        component: () => import('@/views/appClient/rechargeLogAll'),
        meta: { title: '充值记录', permissions: ['admin', 'rechargeLogAll'] },
      },
      {
        path: '/app-client/accountLog',
        name: 'appClientAccountLog',
        component: () => import('@/views/appClient/accountLog'),
        meta: {
          title: '账户明细',
          permissions: ['admin', 'appClientAccountLog'],
        },
        hidden: true,
      },
      {
        path: '/app-client/rechargeLog',
        name: 'appClientRechargeLog',
        component: () => import('@/views/appClient/rechargeLog'),
        meta: {
          title: '充值记录',
          permissions: ['admin', 'appClientRechargeLog'],
        },
        hidden: true,
      },
      {
        path: '/app-client/quotaLog',
        name: 'appClientQuotaLog',
        component: () => import('@/views/appClient/quotaLog'),
        meta: {
          title: '额度操作日志',
          permissions: ['admin', 'appClientFinance'],
        },
        hidden: true,
      },
      {
        path: '/app-client/quotaAccountLog',
        name: 'appClientQuotaAccountLog',
        component: () => import('@/views/appClient/quotaAccountLog'),
        meta: {
          title: '额度明细',
          permissions: ['admin', 'appClientQuotaAccountLog'],
        },
        hidden: true,
      },
      {
        path: '/app-client/quotaAccountLogAll',
        name: 'appClientQuotaAccountLogAll',
        component: () => import('@/views/appClient/quotaAccountLogAll'),
        meta: {
          title: '全局额度明细',
          permissions: ['admin', 'appClientQuotaAccountLogAll'],
        },
      },
      {
        path: '/app-client/dataCount',
        name: 'appClientDataCount',
        component: () => import('@/views/appClient/dataCount'),
        meta: {
          title: '财务统计',
          permissions: ['admin', 'appClientDataCount'],
        },
        hidden: true,
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'ApiAccount',
    meta: {
      title: '账户管理',
      icon: 'system',
      permissions: ['admin', 'apiAccountList', 'apiAccountRequestLogs'],
    },
    children: [
      {
        path: '/api-account-list',
        name: 'ApiAccountList',
        component: () => import('@/views/apiAccount/index'),
        meta: { title: '账户列表', permissions: ['admin', 'apiAccountList'] },
      },
      {
        path: '/api-account-request-logs',
        name: 'ApiAccountRequestLogs',
        component: () => import('@/views/apiAccount/requestLogs'),
        meta: {
          title: '账户请求日志',
          permissions: ['admin', 'apiAccountRequestLogs'],
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Hotels',
    meta: {
      title: '酒店管理',
      icon: 'jd',
      permissions: [
        'admin',
        'hotelList',
        'roomTypeList',
        'roomStatusList',
        'hotelImageList',
        'hotelConfirmLog',
      ],
    },
    children: [
      {
        path: '/hotelList',
        name: 'HotelList',
        component: () => import('@/views/hotels/hotelList.vue'),
        meta: { title: '酒店列表', permissions: ['admin', 'hotelList'] },
      },
      {
        path: '/roomTypeList',
        name: 'RoomTypeList',
        component: () => import('@/views/hotels/roomTypeList.vue'),
        meta: { title: '房型列表', permissions: ['admin', 'roomTypeList'] },
      },
      {
        path: '/roomStatusList',
        name: 'RoomStatusList',
        component: () => import('@/views/hotels/roomStatusList.vue'),
        meta: { title: '房态列表', permissions: ['admin', 'roomStatusList'] },
      },
      {
        path: '/hotelImageList',
        name: 'HotelImageList',
        component: () => import('@/views/hotels/hotelImageList.vue'),
        meta: { title: '相册列表', permissions: ['admin', 'hotelImageList'] },
      },
      {
        path: '/hotelConfirmLog',
        name: 'HotelConfirmLog',
        component: () => import('@/views/hotels/hotelConfirmLog.vue'),
        meta: {
          title: '酒店关联确认列表',
          permissions: ['admin', 'hotelConfirmLog'],
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'JinJiangHotels',
    meta: {
      title: '锦江酒店管理',
      icon: 'jd',
      permissions: [
        'admin',
        'jinJiangHotelList',
        'jinJiangRoomTypeList',
        'jinJiangRoomStatusList',
        'jinJiangHotelImageList',
        'jinJiangOrderList',
      ],
    },
    children: [
      {
        path: '/jinJiang/orderList',
        name: 'JinJiangOrderList',
        component: () => import('@/views/jinJiangOrder/orderList'),
        meta: {
          title: '订单列表',
          permissions: ['admin', 'jinJiangOrderList'],
        },
      },
      {
        path: '/jinJiang/hotelList',
        name: 'JinJiangHotelList',
        component: () => import('@/views/jinJiangHotels/hotelList.vue'),
        meta: {
          title: '酒店列表',
          permissions: ['admin', 'jinJiangHotelList'],
        },
      },
      {
        path: '/jinJiang/roomTypeList',
        name: 'JinJiangRoomTypeList',
        component: () => import('@/views/jinJiangHotels/roomTypeList.vue'),
        meta: {
          title: '房型列表',
          permissions: ['admin', 'jinJiangRoomTypeList'],
        },
      },
      {
        path: '/jinJiang/roomStatusList',
        name: 'JinJiangRoomStatusList',
        component: () => import('@/views/jinJiangHotels/roomStatusList.vue'),
        meta: {
          title: '房态列表',
          permissions: ['admin', 'jinJiangRoomStatusList'],
        },
      },
      {
        path: '/jinJiang/hotelImageList',
        name: 'JinJiangHotelImageList',
        component: () => import('@/views/jinJiangHotels/hotelImageList.vue'),
        meta: {
          title: '相册列表',
          permissions: ['admin', 'jinJiangHotelImageList'],
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'LongTengHotels',
    meta: {
      title: '龙腾酒店管理',
      icon: 'jd',
      permissions: [
        'admin',
        'longTengHotelList',
        'longTengRoomTypeList',
        'longTengRoomStatusList',
        'longTengHotelImageList',
        'longTengOrderList',
      ],
    },
    children: [
      {
        path: '/longTeng/orderList',
        name: 'LongTengOrderList',
        component: () => import('@/views/longTengOrder/orderList'),
        meta: {
          title: '订单列表',
          permissions: ['admin', 'longTengOrderList'],
        },
      },
      {
        path: '/longTeng/hotelList',
        name: 'LongTengHotelList',
        component: () => import('@/views/longTengHotels/hotelList.vue'),
        meta: {
          title: '酒店列表',
          permissions: ['admin', 'longTengHotelList'],
        },
      },
      {
        path: '/longTeng/roomTypeList',
        name: 'LongTengRoomTypeList',
        component: () => import('@/views/longTengHotels/roomTypeList.vue'),
        meta: {
          title: '房型列表',
          permissions: ['admin', 'longTengRoomTypeList'],
        },
      },
      {
        path: '/longTeng/roomStatusList',
        name: 'LongTengRoomStatusList',
        component: () => import('@/views/longTengHotels/roomStatusList.vue'),
        meta: {
          title: '房态列表',
          permissions: ['admin', 'longTengRoomStatusList'],
        },
      },
      {
        path: '/longTeng/hotelImageList',
        name: 'LongTengHotelImageList',
        component: () => import('@/views/longTengHotels/hotelImageList.vue'),
        meta: {
          title: '相册列表',
          permissions: ['admin', 'longTengHotelImageList'],
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'SuiChuanHotels',
    meta: {
      title: '遂穿酒店管理',
      icon: 'jd',
      permissions: [
        'admin',
        'suiChuanHotelList',
        'suiChuanRoomTypeList',
        'suiChuanPolicyList',
        'suiChuanRoomStatusList',
        'suiChuanOrderList',
      ],
    },
    children: [
      {
        path: '/suiChuan/orderList',
        name: 'SuiChuanOrderList',
        component: () => import('@/views/suiChuanOrder/orderList.vue'),
        meta: {
          title: '订单列表',
          permissions: ['admin', 'suiChuanOrderList'],
        },
      },
      {
        path: '/suiChuan/hotelList',
        name: 'SuiChuanHotelList',
        component: () => import('@/views/suiChuanHotels/hotelList.vue'),
        meta: {
          title: '酒店列表',
          permissions: ['admin', 'suiChuanHotelList'],
        },
      },
      {
        path: '/suiChuan/roomTypeList',
        name: 'SuiChuanRoomTypeList',
        component: () => import('@/views/suiChuanHotels/roomTypeList.vue'),
        meta: {
          title: '房型列表',
          permissions: ['admin', 'suiChuanRoomTypeList'],
        },
      },
      {
        path: '/suiChuan/policyList',
        name: 'SuiChuanPolicyList',
        component: () => import('@/views/suiChuanHotels/policyList.vue'),
        meta: {
          title: '政策列表',
          permissions: ['admin', 'suiChuanPolicyList'],
        },
      },
      {
        path: '/suiChuan/roomStatusList',
        name: 'SuiChuanRoomStatusList',
        component: () => import('@/views/suiChuanHotels/roomStatusList.vue'),
        meta: {
          title: '房态列表',
          permissions: ['admin', 'suiChuanRoomStatusList'],
        },
      },
    ],
  },
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "Rooms",
  //     meta: { title: "房型管理", icon: "fx" , permissions: ["admin","subBasicRoomTypeList","salesRoomTypeList","pushRoomDataLogList"]},
  //     children: [
  //         // {
  //         //     path: "/subBasicRoomTypeList",
  //         //     name: "SubBasicRoomTypeList",
  //         //     component: () => import("@/views/rooms/subBasicRoomTypeList"),
  //         //     meta: { title: "子物理房型列表", permissions: ["admin","subBasicRoomTypeList"] }
  //         // },
  //         {
  //             path: "/salesRoomTypeList",
  //             name: "SalesRoomTypeList",
  //             component: () => import("@/views/rooms/salesRoomTypeList"),
  //             meta: { title: "售卖房型列表", permissions: ["admin","salesRoomTypeList"] }
  //         },
  //     ]
  // },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Order',
    meta: {
      title: '客户对账',
      icon: 'dd',
      permissions: [
        'admin',
        'orderList',
        'jinJiangReconciliation',
        'jinJiangReconciliationLog',
        'ledgerLog',
        'ledgerLogDetail',
        'ledgerChannelCommissionLogs',
        'orderChangeLog',
        'ledgerLogDetailRechargeLog',
        'longTengReconciliation',
        'longTengReconciliationLog',
        'suiChuanReconciliation',
        'suiChuanReconciliationLog',
      ],
    },
    children: [
      {
        path: '/orderList',
        name: 'OrderList',
        component: () => import('@/views/order/orderList'),
        meta: { title: '订单明细', permissions: ['admin', 'orderList'] },
      },
      {
        path: '/OrderChangeLog',
        name: 'orderChangeLog',
        component: () => import('@/views/order/OrderChangeLog'),
        meta: {
          title: '订单修改记录',
          permissions: ['admin', 'orderChangeLog'],
        },
      },
      {
        path: '/jinJiangReconciliation',
        name: 'JinJiangReconciliation',
        component: () => import('@/views/order/reconciliation'),
        meta: {
          title: '锦江对账',
          permissions: ['admin', 'jinJiangReconciliation'],
        },
      },
      {
        path: '/jinJiangReconciliationLog',
        name: 'JinJiangReconciliationLog',
        component: () => import('@/views/order/reconciliationLog'),
        meta: {
          title: '锦江对账记录',
          permissions: ['admin', 'jinJiangReconciliationLog'],
        },
      },
      {
        path: '/longTengReconciliation',
        name: 'LongTengReconciliation',
        component: () => import('@/views/order/longTengReconciliation'),
        meta: {
          title: '龙腾对账',
          permissions: ['admin', 'longTengReconciliation'],
        },
      },
      {
        path: '/longTengReconciliationLog',
        name: 'LongTengReconciliationLog',
        component: () => import('@/views/order/longTengReconciliationLog'),
        meta: {
          title: '龙腾对账记录',
          permissions: ['admin', 'longTengReconciliationLog'],
        },
      },
      {
        path: '/suiChuanReconciliation',
        name: 'SuiChuanReconciliation',
        component: () => import('@/views/order/suiChuanReconciliation'),
        meta: {
          title: '遂穿对账',
          permissions: ['admin', 'suiChuanReconciliation'],
        },
      },
      {
        path: '/suiChuanReconciliationLog',
        name: 'SuiChuanReconciliationLog',
        component: () => import('@/views/order/suiChuanReconciliationLog'),
        meta: {
          title: '遂穿对账记录',
          permissions: ['admin', 'suiChuanReconciliationLog'],
        },
      },
      {
        path: '/ledgerLog',
        name: 'LedgerLog',
        component: () => import('@/views/order/ledgerLog'),
        meta: { title: '台账创建记录', permissions: ['admin', 'ledgerLog'] },
      },

      {
        path: '/ledgerLogDetail',
        name: 'LedgerLogDetail',
        component: () => import('@/views/order/ledgerLogDetail'),
        meta: {
          title: '客户对账明细',
          permissions: ['admin', 'ledgerLogDetail'],
        },
      },
      {
        path: '/ledgerChannelCommissionLogs',
        name: 'LedgerChannelCommissionLogs',
        component: () => import('@/views/order/ledgerChannelCommissionLogs'),
        meta: {
          title: '渠道佣金台账明细',
          permissions: ['admin', 'ledgerChannelCommissionLogs'],
        },
      },
      {
        path: '/orderDetail',
        name: 'OrderDetail',
        component: () => import('@/views/order/orderDetail'),
        meta: { title: '订单明细', permissions: ['admin', 'ledgerLogDetail'] },
        hidden: true,
      },
      {
        path: '/orderDetailShow',
        name: 'OrderDetailShow',
        component: () => import('@/views/order/orderDetailShow'),
        meta: { title: '订单详情展示', permissions: ['admin', 'orderList'] },
        hidden: true,
      },
      {
        path: '/operationLog',
        name: 'OperationLog',
        component: () => import('@/views/order/OperationLog'),
        meta: { title: '订单操作日志', permissions: ['admin', 'orderList'] },
        hidden: true,
      },
      {
        path: '/ledgerLogDetail/rechargeLog',
        name: 'ledgerLogDetailRechargeLog',
        component: () => import('@/views/order/rechargeLog'),
        meta: {
          title: '充值日志',
          permissions: ['admin', 'ledgerLogDetailRechargeLog'],
        },
        hidden: true,
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'System',
    meta: {
      title: '建站管理',
      icon: 'content',
      permissions: ['admin', 'system', 'notification'],
    },
    children: [
      {
        path: '/system/config',
        name: 'system',
        component: () => import('@/views/system/config'),
        meta: { title: '参数设置', permissions: ['admin', 'system'] },
      },
      {
        path: '/system/notification',
        name: 'notification',
        component: () => import('@/views/system/notification'),
        meta: { title: '通知配置管理', permissions: ['admin', 'notification'] },
      },
    ],
  },
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "User",
  //     meta: {title: "用户管理", permissions: ["admin", "user"], icon: "users"},
  //     children: [
  //         {
  //             path: "/user/list",
  //             name: "Users",
  //             component: () => import("@/views/user/index"),
  //             meta: {title: "用户列表", permissions: ["admin", "user"]}
  //         }
  //     ]
  // },
  //
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "Content",
  //     meta: {
  //         title: "内容管理",
  //         permissions: ["banner", "about"],
  //         icon: "content"
  //     },
  //     children: [
  //         {
  //             path: "/banner/list",
  //             name: "Banners",
  //             component: () => import("@/views/banner/index"),
  //             meta: {title: "轮播图设置", permissions: ["banner"]}
  //         },
  //         {
  //             path: "/about",
  //             name: "About",
  //             component: () => import("@/views/about/index"),
  //             meta: {title: "关于我们", permissions: ["about"]}
  //         }
  //     ]
  // },

  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "Others",
  //     meta: {title: "其他", icon: "others"},
  //     children: [
  //         {
  //             path: "/map",
  //             name: "Map",
  //             component: () => import("@/views/others/map"),
  //             meta: {title: "地图"}
  //         }
  //     ]
  // },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Admin',
    meta: {
      title: '管理员设置',
      permissions: ['admin', 'adminList', 'role'],
      icon: 'system',
    },
    children: [
      {
        path: '/roles',
        name: 'Role',
        component: () => import('@/views/role/index'),
        meta: { title: '角色列表', permissions: ['admin', 'role'] },
      },
      {
        path: '/admin/list',
        name: 'Admin',
        component: () => import('@/views/admin/index'),
        meta: { title: '管理员列表', permissions: ['admin', 'adminList'] },
      },
    ],
  },
  { path: '*', redirect: '/error/404', hidden: true },
]
